import { createFileRoute } from "@tanstack/react-router";

import { CustomerPage } from "../../../features/customers/customer-page";

export const Route = createFileRoute("/_app/customers/$id")({ component: CustomerRoute });

function CustomerRoute() {
  const { id } = Route.useParams();
  return <CustomerPage key={id} id={id} />;
}
